import { Box } from "@mui/material";
import CustomModal from "components/lib/customModal";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "@mindlercare/ui-web";
import { Typography } from "components/typography";

type ConfirmPhoneNumberDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  phoneNumber: string | null;
};

export const ConfirmPhoneNumberDialog = ({
  isOpen,
  phoneNumber,
  onClose,
  onConfirm,
}: ConfirmPhoneNumberDialogProps) => {
  const { t } = useTranslation();

  return (
    <CustomModal.Wrapper
      size="small"
      onClose={onClose}
      open={isOpen}
      titleText={t("CONFIRM_PHONE_NUMBER")}
    >
      <Typography
        variant="body"
        sx={{
          textAlign: "center",
          marginBottom: "24px",
          color: "GRAY_DARK",
        }}
      >
        <Trans
          i18nKey="CONFIRM_PHONE_NUMBER_TEXT"
          values={{
            phone: phoneNumber,
          }}
          components={{
            strong: <Typography variant="body-bold" />,
          }}
        />
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box sx={{ marginRight: "10px" }}>
          <Button variant="secondary" disabled={false} onClick={onClose}>
            {t("CANCEL")}
          </Button>
        </Box>
        <Button
          variant="primary"
          style={{ marginLeft: "10px" }}
          onClick={onConfirm}
        >
          {t("CONFIRM")}
        </Button>
      </Box>
    </CustomModal.Wrapper>
  );
};
